import styled from 'styled-components';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';

export const Container = styled.div`
	display: none;
	justify-content: center;
	align-items: center;

	width: 75px;
	height: 75px;
	position: fixed;

	right: 35px;
	bottom: 35px;

	border-radius: 50%;
	box-shadow: 1px 4px 13px -9px rgba(0, 0, 0, 0.69);

	background-color: var(--dark-blue);
	color: var(--white);

	font-size: 35px;

	z-index: 2;

	cursor: pointer;

	transition: all ease 0.2s;

	&.show {
		display: flex;
	}

	:hover {
		background-color: var(--light-blue);
	}
`;

export const ArrowUp = styled(ArrowDropUp)`
	font-size: 50px;
`;
